import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DragControls } from "three/examples/jsm/controls/DragControls.js";
import gsap from 'gsap'
import { Box2, Mesh } from 'three';
import CANNON, { World } from 'cannon';
import CannonDebugger from 'cannon-es-debugger'

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
const world = new CANNON.World()
const cannonDebugger = new CannonDebugger(scene, world, {
  // options...
})
world.gravity.set(0, - 9.82, 0)

//plateform

const plateFormGeometry = new THREE.BoxGeometry(10.3, 2, 1.5)
const plateFormMaterial = new THREE.MeshBasicMaterial({color:0xDC2C1D})  

const plateform =new THREE.Mesh(plateFormGeometry,plateFormMaterial);
scene.add(plateform);

plateform.position.y = 2 *0.5
plateform.position.z = 4
plateform.position.x = 0.84 


/**
 * Object
 */
const geometry = new THREE.BoxGeometry(12, 0.1, 20)
const material = new THREE.MeshStandardMaterial({color:'white'})  
const loader =new THREE.CubeTextureLoader() 
const mesh = new THREE.Mesh(geometry, material)
const mesh1 = new THREE.Mesh(geometry, material)

const geometry1 = new THREE.BoxGeometry(12, 6, 0.1)
const wall = new THREE.Mesh(geometry1, material)

const loadingManager = new THREE.LoadingManager()
const textureLoader =new THREE.TextureLoader(loadingManager);
const colorTexture =  textureLoader.load('/images/floor/floor12.png')
const wallTexture =  textureLoader.load('/images/floor/brick.png')
const ceilingTexture =  textureLoader.load('/images/floor/ceil.png')
const menuTexture =  textureLoader.load('/images/floor/mmv.png')
const logoTexture =  textureLoader.load('/images/floor/mmvlogo.png')
const screenLogo =  textureLoader.load('/images/floor/screen.png')
const display1 =  textureLoader.load('/images/floor/display1.png')
const display2 =  textureLoader.load('/images/floor/display2.png')
const display3 =  textureLoader.load('/images/floor/display3.png')
const display5 =  textureLoader.load('/images/floor/display5.png')
const display6 =  textureLoader.load('/images/floor/display6.png')
const parking =  textureLoader.load('/images/floor/parking1.png')
const keyboardLogo =  textureLoader.load('/images/floor/keyboard.png')


const planeGeometry = new THREE.PlaneGeometry(12,20)
const planeMaterial = new THREE.MeshBasicMaterial({map:colorTexture,side:THREE.DoubleSide})  
const plane = new THREE.Mesh(planeGeometry, planeMaterial)
const planeGeometry4 = new THREE.PlaneGeometry(12,6)

const planeGeometry1 = new THREE.PlaneGeometry(20,6)
const planeMaterial1 = new THREE.MeshBasicMaterial({map:wallTexture,side:THREE.DoubleSide})  
const ceilPlaneMaterial = new THREE.MeshBasicMaterial({map:ceilingTexture,side:THREE.DoubleSide})  

const plane5 = new THREE.Mesh(planeGeometry, ceilPlaneMaterial)
const plane1 = new THREE.Mesh(planeGeometry1, planeMaterial1)
const plane2 = new THREE.Mesh(planeGeometry1, planeMaterial1)

const plane4 = new THREE.Mesh(planeGeometry4, planeMaterial1)

const geometry2 = new THREE.BoxGeometry(0.1, 6, 20)
const wall1 = new THREE.Mesh(geometry2, material)
const wall2 = new THREE.Mesh(geometry2, material)

const tvBoxGeometry = new THREE.BoxGeometry(0.1, 1, 2)
const tvBoxMaterial = new THREE.MeshBasicMaterial({color:"black"})  
const tvBox = new THREE.Mesh(tvBoxGeometry, tvBoxMaterial)
scene.add(tvBox)
tvBox.position.set(5.85,5,-5.8)


//speaker
const speakerBoxGeometry = new THREE.BoxGeometry(0.2, 0.2, 2)
const speakerBoxMaterial = new THREE.MeshBasicMaterial({color:"black"})  
const speakerBox = new THREE.Mesh(speakerBoxGeometry, speakerBoxMaterial)
scene.add(speakerBox)
speakerBox.position.set(5.85,4.22,-5.8)


const planeGeometryTv = new THREE.PlaneGeometry(2,0.8)

var video = document.getElementById("video");
const videoTexture = new THREE.VideoTexture(video);
videoTexture.needsUpdate = true;
const videoMaterial = new THREE.MeshBasicMaterial({
    map: videoTexture,
    side: THREE.BackSide,
    toneMapped: false,
});
videoMaterial.needsUpdate = true;

const planeTv = new THREE.Mesh(planeGeometryTv, videoMaterial)
// var tvOn = document.getElementById("tv");
// tvOn.addEventListener("click", TV);

document.body.onclick=function(){
    scene.add(planeTv)
    video.play();
}


//Food menu
const menuCard = (s1,s2,x,y,z)=>{
  const menuGeometry = new THREE.PlaneGeometry(s1,s2);
  const menuMaterial = new THREE.MeshBasicMaterial({map:menuTexture})
  const menu = new Mesh(menuGeometry,menuMaterial);
  scene.add(menu);
  
  menu.position.set(x,y,z);
  
  menu.rotation.y = Math.PI
  menu.rotation.x = Math.PI/2
  return menu;
  
}

menuCard(1.4,0.7,1.7,2.01,4); // menu 1 on desk
menuCard(1.4,0.7,0.2,2.01,4); //menu2 on desk
menuCard(1,0.5,3.7,1.28,0)  //menu on table 1
menuCard(1,0.5,3.7,1.28,-4)  //menu on table 2
menuCard(1,0.5,3.7,1.28 ,-8) //menu on table 3

//mmvlogo
const logoGeometry = new THREE.PlaneGeometry(5,1);
const logoMaterial = new THREE.MeshBasicMaterial({map:logoTexture})
const logo = new Mesh(logoGeometry,logoMaterial);
scene.add(logo);

logo.position.x=1
logo.position.y=1
logo.position.z= 3.24

logo.rotation.y = Math.PI
// menu.rotation.x = Math.PI/2


//computer1 
const computerGeometry = new THREE.BoxGeometry(1.6, 0.8, 0.1)
const compiuterMaterial = new THREE.MeshBasicMaterial({color:'black'});
const computer = new Mesh(computerGeometry,compiuterMaterial);
computer.position.set(4,2,1);

//screen
const screenGeometry = new THREE.PlaneGeometry(1.5,0.7)
const screenMaterial = new THREE.MeshBasicMaterial({map:screenLogo,side:THREE.DoubleSide});
const screen = new Mesh(screenGeometry,screenMaterial);
screen.position.set(4,2,1.055);

//stand
const standgeometry = new THREE.ConeGeometry( 0.21, 0.4, 3 );
const stand = new THREE.Mesh( standgeometry, compiuterMaterial );
stand.position.set(3.95,1.5,0.99);
 
//keyboard
const keyboardGeometry = new THREE.BoxGeometry(1.5, 0.05, 0.4)
const keyboard = new THREE.Mesh( keyboardGeometry, compiuterMaterial );
keyboard.position.set(3.95,1.3,1.5);

//KeyboardScreen
const keyboardScreenGeometry = new THREE.PlaneGeometry(1.5,0.4)
const keyboardScreenMaterial = new THREE.MeshBasicMaterial({map:keyboardLogo,side:THREE.FrontSide});
const keyboardScreen = new Mesh(keyboardScreenGeometry,keyboardScreenMaterial);
keyboardScreen.position.set(3.95,1.33,1.5);
keyboardScreen.rotation.x =-Math.PI/2
keyboardScreen.rotation.z =3.14*2


//computer Group1
const groupComputer = new THREE.Group();
groupComputer.add(computer,screen,stand,keyboard,keyboardScreen);
scene.add(groupComputer);

groupComputer.position.set(0,0.7,2.9)


//computer Group2
const groupComputer1 = new THREE.Group();
groupComputer1.copy(groupComputer);
scene.add(groupComputer1);

groupComputer1.position.set(-6,0.7,2.9)

//wallPoster

const wallPaster= (x,y,z,picture)=>{
  const wallScreenGeometry = new THREE.PlaneGeometry(1,0.5)
  const wallScreenMaterial = new THREE.MeshBasicMaterial({map:picture,side:THREE.DoubleSide});
  const wallScreen = new Mesh(wallScreenGeometry,wallScreenMaterial);
  wallScreen.position.set(x,y,z);
  wallScreen.rotation.y = Math.PI/2
  scene.add(wallScreen)

  return wallPaster;
}

wallPaster(5.88,4.5,0,display1)
wallPaster(-5.88,4.5,1.055,display2)
wallPaster(5.88,3.5,-3.055,display3)
wallPaster(-5.88,4,-3.055,display5)
wallPaster(-5.88,4.5,-8.055,display6)


//front OuterArea

const frontGeometry = new THREE.BoxGeometry(12, 0.1, 5)
const frontMaterial = new THREE.MeshBasicMaterial({map:parking})  
const frontArea = new THREE.Mesh(frontGeometry,frontMaterial)
scene.add(frontArea)
frontArea.position.set(0,0.01,-12.5);


/**
 * Fonts
 */
 const fontLoader = new FontLoader()


 const text = (name,x,y,z,xr,yr,zr)=>{

 fontLoader.load(
  '/fonts/helvetiker_regular.typeface.json',
  (font) =>
  {
   const textGeometry = new TextGeometry(
     name,
     {
         font: font,
         size: 0.06,
         height: 0.05,
         curveSegments: 12,
        
     }
 )
 const matcapTexture = textureLoader.load('/images/ny.png')
 const textMaterial = new THREE.MeshMatcapMaterial({ matcap: matcapTexture })
 const text = new THREE.Mesh(textGeometry, textMaterial)
 text.position.set(x,y,z)
 text.rotation.set(xr,yr,zr)
 scene.add(text)
  }
)
 }

 text("boAt",5.8,4.19,-6,0,-1.6,0);
 text("Sony",5.84,4.55,-6,0,-1.6,0)
 

const environmentMapTexture = loader.load([
   '/images/BaseTile/px.png',
   '/images/BaseTile/nx.png',
   '/images/BaseTile/py.png',
   '/images/BaseTile/ny.png',
   '/images/BaseTile/pz.png',
   '/images/BaseTile/nz.png'
])
material.envMap = environmentMapTexture

scene.background =environmentMapTexture
scene.add(mesh)
scene.add(mesh1)

scene.add(wall)
scene.add(wall1)
scene.add(wall2)

scene.add(plane)
scene.add(plane1)
scene.add(plane2)
scene.add(plane4)
scene.add(plane5)

wall.position.set(0,3.05,9.95)
wall1.position.set(5.95,3.05,0)
wall2.position.set(-5.95,3.05,0)
plane.position.set(0,0.06,0)
mesh1.position.set(0,6,0)
plane.rotation.x =Math.PI/2;

plane1.position.set(5.89,3.06,0)
plane1.rotation.y =Math.PI/2;

plane2.position.set(-5.89,3.06,0)
plane2.rotation.y =Math.PI/2;
plane4.position.set(0,3.06,9.89)

plane5.rotation.x =Math.PI/2;
plane5.position.set(0,5.94,0)

planeTv.rotation.y =1.57;
planeTv.position.set(5.79,5.1,-5.8)


/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 1, 1000)
camera.position.z = -12
camera.position.y = 5
camera.position.x = 0

camera.rotation.x  =Math.PI*2
scene.add(camera) 


// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))


  /**
   * light
*/
const ambientLight = new THREE.AmbientLight(0xffffff, 1.2)
scene.add(ambientLight)
 
/**
 * Loading
 */


 const loadingBarElement = document.querySelector('.loading-bar');

 const loadingManager1 = new THREE.LoadingManager(
     // Loaded
     () => {
 
         gsap.delayedCall(0.5,()=>{
             gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0 });
             loadingBarElement.classList.add('ended');
             loadingBarElement.style.transform = ''
         })
     },
 
     // Process
     (itemUrl, itemsLoaded, itemsTotal) => {
         const progressRation = itemsLoaded / itemsTotal;
         loadingBarElement.style.transform = `scaleX(${progressRation})`
         console.log(progressRation);
     },
 );
 
 const overlayGeometry = new THREE.PlaneBufferGeometry(2, 2, 1, 1);
 const overlayMaterial = new THREE.ShaderMaterial({
     transparent: true,
     uniforms:
     {
         uAlpha: { value: 1 }
     },
     vertexShader: `
         void main()
         {
             gl_Position =  vec4(position, 1.0);
         }
     `,
     fragmentShader: `
         uniform float uAlpha;
 
         void main()
         {
             gl_FragColor = vec4(0.0, 0.0, 0.0, uAlpha);
         }
     `
 });
 const overlay = new THREE.Mesh(overlayGeometry, overlayMaterial);
 scene.add(overlay);


const GltfLoader = new GLTFLoader(loadingManager1);
    
var objects = [];

const dChair = (x,y,z,rx,ry,rz) => {
  return GltfLoader.load("/models/chair/country_style_chair.glb", function (gltf) {
     const model = gltf.scene;

     var material = new THREE.MeshBasicMaterial({ color: 0xDC2C1D });
     model.traverse(function (child) {
                         if (child instanceof THREE.Mesh) {
                             child.material = material;
                         }
                     })
     model.position.set(x,y,z) 
     model.rotation.x = rx;
     model.rotation.y = ry;
     model.rotation.z = rz;
    //  model.rotation.y = Math.PI * 0.14;

     model.scale.set(0.2,0.2,0.2)
     scene.add(model);
   });
 }

 dChair(5.3,0.7,0,0,Math.PI *0.14,0)
 dChair(4,0.7,0,0,Math.PI *0.14,0)

 dChair(5.3,0.7,-4,0,Math.PI *0.14,0)
 dChair(4,0.7,-4,0,Math.PI *0.14,0)

 dChair(5.3,0.7,-8,0,Math.PI *0.14,0)
 dChair(4,0.7,-8,0,Math.PI *0.14,0)

 //opposit direction chair
 dChair(5,0.7,0,0,3.6,0)
 dChair(3.7,0.7,0,0,3.6,0)

 dChair(5,0.7,-4,0,3.6,0)
 dChair(3.7,0.7,-4,0,3.6,0)

 dChair(5,0.7,-8,0,3.6,0)
 dChair(3.7,0.7,-8,0,3.6,0)


  const Light = (x,y,z) => {
   return GltfLoader.load("/models/ceiling_light.glb", function (gltf) {
      const model = gltf.scene;
      model.position.set(x,y,z) 
      model.scale.set(0.5,0.5,0.5)
      scene.add(model);
    });

  }

  Light(4,5.9,7.5);
  Light(-4,5.9,7.5);
  Light(4,5.9,1.5);
  Light(-4,5.9,1.5);
  Light(4,5.9,-3.5);
  Light(-4,5.9,-3.5);
  Light(4,5.9,-7.5);
  Light(-4,5.9,-7.5);

  GltfLoader.load("/models/ceiling_lamp_03.glb", function (gltf) {
    const model = gltf.scene;
    scene.add(model);
    model.position.set(1,5,3.8)
    model.rotation.y = 1.5;
    model.scale.set(3,2,2)

  });
  

  const posMachine = (x,y,z) => {
    return GltfLoader.load("/models/pos.glb", function (gltf) {
       const model = gltf.scene;
       model.position.set(x,y,z) 
       model.scale.set(0.2,0.2,0.2)
      
       scene.add(model);
      
     });
 
   }

   posMachine(2.8,2.02,4.2)
   posMachine(-0.8,2.02,4.2)

const dTable = (x,y,z,rx,ry,rz) => {
  return GltfLoader.load("/models/folding_table.glb", function (gltf) {
     const model = gltf.scene;
     var material = new THREE.MeshBasicMaterial({ color: 'white' });
     model.traverse(function (child) {
                         if (child instanceof THREE.Mesh) {
                             child.material = material;
                         }
                     })
     
     
     model.position.set(x,y,z) 
     model.scale.set(1.5,1.5,1)
     model.rotation.x = rx;
     model.rotation.y = ry;
     model.rotation.z = rz;
     scene.add(model);
   });
 }

 dTable(4.5,0.67,0,0,0,0)
 dTable(4.5,0.67,-4,0,0,0)
 dTable(4.5,0.67,-8,0,0,0)

//  dTable(-3.5,0.5,-2,0,1.6,0)
//  dTable(-3.6,0.5,-5,0,1.6,0)


const sofaNew = (x,y,z) => {
    return GltfLoader.load("/models/sofa_pink.glb", function (gltf) {
       const model = gltf.scene;

        model.position.set(x,y,z) 
    //    model.scale.set(0.04,0.02,0.02)
       model.scale.set(0.0013,0.0013,0.002)

       model.rotation.y = 1.6
       scene.add(model);
     });
   }

   sofaNew(-4,0.29,1);
   sofaNew(-4,0.29,-4.5);


let menmodel;
   const men = (x,y,z,rx,ry,rz) => {
    return GltfLoader.load("/models/tomer.glb", function (gltf) {
      menmodel = gltf.scene;
      menmodel.position.set(x,y,z) 
      menmodel.scale.set(0.5,0.4,0.5)
      menmodel.rotation.x = rx;
      menmodel.rotation.y = ry;
      menmodel.rotation.z = rz;
        scene.add(menmodel);
     });
   }
// men(-1,0.32,-0.7,0,0,0)
// men(3,0.32,-0.7,0,0,0)

  men(-2,0.32,8.6,0,3,0)
  men(2.8,0.32,8.6,0,3,0)

   const ketchup = (x,y,z) => {
    return GltfLoader.load("/models/ketchup.glb", function (gltf) {
       const model = gltf.scene;
       model.position.set(x,y,z) 
       model.scale.set(0.13,0.1,0.1)
       scene.add(model);
     });
 
   }
   
   ketchup(4.5,1.45,-0.2);
   ketchup(4.5,1.45,-4.2);
   ketchup(4.5,1.45,-8.2);


   const tissue = (x,y,z) => {
    return GltfLoader.load("/models/tissue_box.glb", function (gltf) {
       const model = gltf.scene;
       var material = new THREE.MeshBasicMaterial({ color: 'rwhite' });
      //  model.traverse(function (child) {
      //                      if (child instanceof THREE.Mesh) {
      //                          child.material = material;
      //                      }
      //                  })
       model.position.set(x,y,z) 
       model.scale.set(0.13,0.1,0.1)
       model.rotation.set(0,3,0) 

       scene.add(model);
     });
 
   }
   tissue(-3.5,2,4)

const menShape= new CANNON.Box(new CANNON.Vec3(0.67,1.7,0.5));
const menBody = new CANNON.Body({
  shape:menShape,
  mass:1,
  type:CANNON.Body.DYNAMIC,
  position: new CANNON.Vec3(-0.976, 1.78, 2.7)

})

const menBody1 = new CANNON.Body({
  shape:menShape,
  mass:1,
  type:CANNON.Body.DYNAMIC,
  position: new CANNON.Vec3(3.03, 1.78, 2.7)

})
world.addBody(menBody);
world.addBody(menBody1)
var dragControls = new DragControls(objects, camera, renderer.domElement);
dragControls.addEventListener("dragstart", function (event) {
  controls.enabled = false;
});

dragControls.addEventListener("dragend", function (event) {
  controls.enabled = true;
});


/**
 * Animate
 */
const clock = new THREE.Clock()
let prevTime=0
let angle = 0

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()

    const deltaTime =  elapsedTime-prevTime;
    prevTime=elapsedTime;
    // Update controls
    controls.update()
    // cannonDebugger.update()
  
    controls.maxPolarAngle = Math.PI * 0.48;

    angle += 0.01;

    renderer.render(scene, camera)
    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

renderer.domElement.addEventListener('dblclick', onMouseClick, false);

function onMouseClick(event) {

    var mouse = new THREE.Vector2();
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    var raynewcaster = new THREE.Raycaster();
    raynewcaster.setFromCamera(mouse,camera);

    var intersectss = raynewcaster.intersectObjects(scene.children);

    if(intersectss.length > 0) {

        // camera.position.copy(intersectss[0].point);

       const targetPosition = intersectss[0].point;

        animateCubeToPosition( targetPosition );
    }
}

function animateCubeToPosition(targetPosition, duration = 1000) {
    const initialPosition = camera.position.clone();
    let startTime = null;

    function update(time) {
        if(!startTime) startTime = time;
        const elapsedTime = time - startTime;
        const t = Math.min(elapsedTime / duration, 1);

        const newPosition = initialPosition.clone().lerp(targetPosition,t);
        camera.position.copy(newPosition);

        if(t < 1) {
            requestAnimationFrame(update);
        }
    }
    requestAnimationFrame(update);
}

tick()